export default {"src":"/_next/static/media/check-icon.e749e190.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};